import { Tooltip, Typography } from '@mui/material';

interface GridCellTooltipProps {
  value: string;
  maxWidth?: number | string;
}

/** Truncates long grid cell text and shows the full value on hover. */
export default function GridCellTooltip({ value, maxWidth = '100%' }: GridCellTooltipProps) {
  const text = value?.trim() || '-';
  if (text === '-') {
    return (
      <Typography variant="caption" color="text.secondary" noWrap sx={{ maxWidth }}>
        {text}
      </Typography>
    );
  }
  return (
    <Tooltip title={text} arrow placement="top-start">
      <Typography variant="caption" color="text.secondary" noWrap sx={{ maxWidth, cursor: 'default' }}>
        {text}
      </Typography>
    </Tooltip>
  );
}
